module.exports = __webpack_public_path__ + "static/media/FZ_colorful_background.2d49d70b.jpg";